export default __webpack_public_path__ + "static/media/need-deposit.e17074b8.webp";